import * as React from 'react';
import Accordion, { accordionClasses } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails, { accordionDetailsClasses } from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from '@mui/material/Fade';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Accordion": Accordion, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/Typography": Typography, "@mui/icons-material/ExpandMore": ExpandMoreIcon, "@mui/material/Fade": Fade } } });
export default ClientProvider;
